import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
  id: "permission-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#permission-tab-pane",
  type: "button",
  role: "tab",
  "aria-selected": "false"
}
const _hoisted_6 = {
  key: 0,
  class: "badge bg-success ms-1",
  style: {"font-size":"0.65rem"}
}
const _hoisted_7 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "edit-user-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12 mb-20" }
const _hoisted_11 = { class: "d-flex align-items-center gap-3" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "d-flex gap-2" }
const _hoisted_14 = { class: "col-md-6 mb-20" }
const _hoisted_15 = { class: "col-md-6 mb-20" }
const _hoisted_16 = { class: "col-md-12 mb-20" }
const _hoisted_17 = { class: "col-md-6 mb-20" }
const _hoisted_18 = { class: "col-md-6 mb-20" }
const _hoisted_19 = { class: "col-md-12 d-flex align-items-center justify-content-between mt-10" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_22 = {
  class: "tab-pane fade",
  id: "permission-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_23 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_24 = { class: "text-muted small mt-1" }
const _hoisted_25 = { class: "fw-semibold text-success" }
const _hoisted_26 = { class: "d-flex align-items-center gap-2" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_31 = {
  key: 0,
  class: "text-center py-5 text-muted"
}
const _hoisted_32 = {
  key: 1,
  class: "perm-list"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "d-flex align-items-center gap-3" }
const _hoisted_35 = { class: "fw-medium text-dark small" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = {
  key: 2,
  class: "text-center py-5 text-muted small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
            id: "edit-user-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#edit-user-tab-pane",
            type: "button",
            role: "tab",
            "aria-selected": "true"
          }, " Informations ")
        ], -1)),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _cache[13] || (_cache[13] = _createTextVNode(" Permissions ", -1)),
            (_ctx.totalEnabled > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.totalEnabled), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Photo de profil", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    src: _ctx.imagepreview || require('@/assets/images/NoImage.png'),
                    class: "rounded-circle",
                    style: {"width":"80px","height":"80px","object-fit":"cover","border":"2px solid #e9ecef"}
                  }, null, 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("input", {
                      ref: "updateImgInput",
                      type: "file",
                      accept: "image/*",
                      class: "d-none",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                    }, null, 544),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary btn-sm",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                    }, " Choisir "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary btn-sm",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                    }, " Annuler ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom complet *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userData.name) = $event)),
                  type: "text",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "Nom complet",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Téléphone *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userData.phone) = $event)),
                  type: "text",
                  pattern: "^0[0-9]{9}$",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "0XXXXXXXXX",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Email *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userData.email) = $event)),
                  type: "email",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "exemple@email.com",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot de passe *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userData.password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "••••••••",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.password]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Confirmation *", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userData.c_password) = $event)),
                  type: "password",
                  class: "form-control shadow-none rounded-0",
                  placeholder: "••••••••",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.userData.c_password]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-success px-4",
                  disabled: _ctx.loading
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                    : _createCommentVNode("", true),
                  _cache[21] || (_cache[21] = _createTextVNode(" Enregistrer ", -1))
                ], 8, _hoisted_20),
                _createVNode(_component_router_link, {
                  to: "/users-list",
                  class: "btn btn-link text-danger"
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("Annuler", -1)
                  ])),
                  _: 1,
                  __: [22]
                })
              ])
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", null, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "fw-bold text-dark fs-15" }, "Permissions d'accès", -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.totalEnabled), 1),
                _createTextVNode(" / " + _toDisplayString(_ctx.permissionsData.length) + " activées ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-success",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.enableAll && _ctx.enableAll(...args))),
                disabled: _ctx.totalEnabled === _ctx.permissionsData.length
              }, " Tout activer ", 8, _hoisted_27),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-secondary",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.disableAll && _ctx.disableAll(...args))),
                disabled: _ctx.totalEnabled === 0
              }, " Tout désactiver ", 8, _hoisted_28),
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm px-4",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.AddPerms && _ctx.AddPerms(...args))),
                disabled: _ctx.load
              }, [
                (_ctx.load)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                  : _createCommentVNode("", true),
                _cache[24] || (_cache[24] = _createTextVNode(" Enregistrer ", -1))
              ], 8, _hoisted_29)
            ])
          ]),
          (_ctx.permsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[25] || (_cache[25] = [
                _createElementVNode("div", { class: "spinner-border spinner-border-sm me-2" }, null, -1),
                _createTextVNode(" Chargement... ", -1)
              ])))
            : (_ctx.permissionsData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionsData, (perm) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: perm.id,
                      class: _normalizeClass(["perm-item d-flex align-items-center justify-content-between", { 'perm-item--on': perm.checked }]),
                      onClick: ($event: any) => (perm.checked = !perm.checked)
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["perm-dot", perm.checked ? 'perm-dot--on' : ''])
                        }, null, 2),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(perm.name), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "form-check form-switch mb-0",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((perm.checked) = $event),
                          class: "form-check-input",
                          type: "checkbox",
                          style: {"cursor":"pointer","width":"2.2em","height":"1.1em"}
                        }, null, 8, _hoisted_36), [
                          [_vModelCheckbox, perm.checked]
                        ])
                      ])
                    ], 10, _hoisted_33))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_37, " Aucune permission disponible. "))
        ])
      ])
    ])
  ]))
}